import React, { useEffect, useState } from "react";
import Loader from "../../components/Loader/Loader";
import CustomInput from "../../components/UI/CustomInput/CustomInput";
import classes from "./Registration.module.css";
import { getCitiesList } from "../../api/citiesAPI";

const Registration = () => {
    const [loading, setLoading] = useState(false);
    const [list, setList] = useState([]);
    const [inputs, setInputs] = useState({
        firstName: "",
        lastName: "",
        type: "",
        email: "",
        city: "",
        phone: "",
    });

    const registrationHandler = () => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
        }, 3000);
    };

    useEffect(() => {
        getCitiesList(inputs.city, 0, 0, cities => {
            setList(cities as any);
        });
    }, [inputs.city]);

    return (
        <>
            {loading ? (
                <Loader />
            ) : (
                <>
                    <div className={classes.registration}>
                        <div className={classes.registration__content}>
                            <h2>Регистрация</h2>
                            <div>
                                {
                                    <form
                                        onSubmit={e => {
                                            e.preventDefault();
                                            registrationHandler();
                                        }}
                                    >
                                        <label>
                                            Фамилия:
                                            <CustomInput
                                                className={classes.registration__inputText}
                                                type="text"
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                                    setInputs({
                                                        ...inputs,
                                                        firstName: e.target.value,
                                                    })
                                                }
                                            />
                                        </label>
                                        <label>
                                            Имя:
                                            <CustomInput
                                                className={classes.registration__inputText}
                                                type="text"
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                                    setInputs({
                                                        ...inputs,
                                                        lastName: e.target.value,
                                                    })
                                                }
                                            />
                                        </label>
                                        <div className={classes.registration__type}>
                                            <div>
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="type"
                                                        value="individual"
                                                        checked={inputs.type === "individual"}
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                                            setInputs({
                                                                ...inputs,
                                                                type: e.target.value,
                                                            })
                                                        }
                                                    />{" "}
                                                    Физ.лицо
                                                </label>
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="type"
                                                        value="legal"
                                                        checked={inputs.type === "legal"}
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                                            setInputs({
                                                                ...inputs,
                                                                type: e.target.value,
                                                            })
                                                        }
                                                    />{" "}
                                                    Юр.лицо
                                                </label>
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="type"
                                                        value="resident"
                                                        checked={inputs.type === "resident"}
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                                            setInputs({
                                                                ...inputs,
                                                                type: e.target.value,
                                                            })
                                                        }
                                                    />{" "}
                                                    Резидент ЦП
                                                </label>
                                            </div>
                                        </div>
                                        <label>
                                            Город:
                                            <CustomInput
                                                className={classes.registration__inputText}
                                                list="cities"
                                                type="text"
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                                    setInputs({
                                                        ...inputs,
                                                        city: e.target.value,
                                                    })
                                                }
                                            />
                                            <datalist id="cities">
                                                {list?.map(city => (
                                                    // @ts-ignore
                                                    <option key={city.id} value={city.title} />
                                                ))}
                                            </datalist>
                                        </label>
                                        <label>
                                            Email:
                                            <CustomInput
                                                className={classes.registration__inputText}
                                                type="text"
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                                    setInputs({
                                                        ...inputs,
                                                        email: e.target.value,
                                                    })
                                                }
                                            />
                                        </label>
                                        <label>
                                            Телефон:
                                            <CustomInput
                                                className={classes.registration__inputText}
                                                type="text"
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                                    setInputs({
                                                        ...inputs,
                                                        phone: e.target.value,
                                                    })
                                                }
                                            />
                                        </label>
                                        <div>
                                            <CustomInput
                                                id={"agree1"}
                                                className={classes.registration__checkbox}
                                                type={"checkbox"}
                                                name="agree"
                                                value="agree1"
                                            />
                                            <label htmlFor={"agree1"}>Согласие 1</label>
                                        </div>
                                        <div>
                                            <CustomInput
                                                id={"agree2"}
                                                className={classes.registration__checkbox}
                                                type={"checkbox"}
                                                name="agree"
                                                value="agree2"
                                            />
                                            <label htmlFor={"agree2"}>Согласие 2</label>
                                        </div>
                                        <input
                                            className={classes.registration__inputButton}
                                            type="submit"
                                            value="Сохранить"
                                        />
                                    </form>
                                }
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default Registration;
